import { OrgId } from "@hex/common";
import React, { useCallback } from "react";

import { LoginOption } from "./LoginOption";
import { startSsoLogin } from "./startSsoLogin";

export interface SsoLoginProps {
  authQueryParams: Record<string, string>;
  embedded: boolean;
  onComplete: () => void;
  onSubmit: () => void;
  orgId: OrgId;
  className?: string;
}

export const SsoLogin: React.ComponentType<SsoLoginProps> = React.memo(
  function SsoLogin({
    authQueryParams,
    className,
    embedded,
    onComplete,
    onSubmit,
    orgId,
  }) {
    const ssoCallback = useCallback(async () => {
      startSsoLogin({
        authQueryParams,
        embedded,
        onComplete,
        onSubmit,
        orgId,
      });
    }, [embedded, orgId, authQueryParams, onSubmit, onComplete]);
    return (
      <LoginOption className={className} onClick={ssoCallback}>
        Log in with <span>SSO</span>
      </LoginOption>
    );
  },
);
